import EcosiaUser from '@ecosia/ecosia-user';

import { MAIN as MAIN_COOKIE } from '~~/common/js/constants/cookies';
import { DEFAULT_LOCALE } from '../../js/constants/i18n';

export const storeModule = {
  namespaced: true,
  state: () => ({
    locale: DEFAULT_LOCALE,
  }),
  mutations: {
    setLocale(st, locale) {
      st.locale = locale;
    },
  },
  actions: {
    nuxtServerInit({ commit }, context) {
      const { app, req } = context;
      const user = req.user || new EcosiaUser({
        cookieString: app.$cookies.get(MAIN_COOKIE),
        userAgent: req.headers['user-agent'],
        acceptLanguage: req.headers['accept-language'],
      });
      const locale = req.locale || user.get('language') || DEFAULT_LOCALE;
      commit('setLocale', locale);
    },
  },
};

export default (store) => {
  store.registerModule('global', storeModule);
};
